module.exports = __webpack_public_path__ + "static/media/10.f53b1bcd.png";